const WeekHeader = () => {
  return (
    <div className="cashier-remittance-calendar-weeks">
      {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
        <div key={day}>{day}</div>
      ))}
    </div>
  );
};

export default WeekHeader;
